// extracted by mini-css-extract-plugin
export default {"slider":"Slider_slider__fzyMf","lottieContainer":"Slider_lottieContainer__aWUbZ","lottie":"Slider_lottie__9OMGg"};